/* ============================================================
   TIMEPIECE - theme scripts
   ============================================================ */
(function () {
  'use strict';

  var scrim = null;

  function getScrim() {
    if (!scrim) scrim = document.querySelector('[data-overlay-scrim]');
    return scrim;
  }

  function showScrim(onClick) {
    var el = getScrim();
    if (!el) return;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    el.onclick = onClick;
  }

  function hideScrim() {
    var el = getScrim();
    if (!el) return;
    el.classList.remove('is-visible');
    el.onclick = null;
    setTimeout(function () { el.hidden = true; }, 300);
  }

  function lockScroll(lock) {
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  /* ---------- Mobile navigation ---------- */
  function initMobileNav() {
    var nav = document.querySelector('[data-mobile-nav]:not([data-lifted])');
    if (!nav) return;

    // The header's wrapper is sticky with its own z-index, which makes it a
    // stacking context. Left inside it, the menu is ranked with the header
    // and ends up underneath the page scrim, dimmed along with everything
    // else. Moving it to the body puts it back above the scrim.
    document.querySelectorAll('body > [data-mobile-nav][data-lifted]').forEach(function (old) { old.remove(); });
    nav.setAttribute('data-lifted', '');
    document.body.appendChild(nav);

    function close() {
      nav.classList.remove('is-open');
      hideScrim();
      lockScroll(false);
    }

    document.querySelectorAll('[data-mobile-nav-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        nav.classList.add('is-open');
        lockScroll(true);
        showScrim(close);
      });
    });

    nav.querySelectorAll('[data-mobile-nav-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
  }

  /* ---------- Search modal ---------- */
  function initSearch() {
    var modal = document.querySelector('[data-search-modal]');
    if (!modal) return;

    function close() {
      modal.classList.remove('is-open');
      lockScroll(false);
    }

    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.classList.add('is-open');
        lockScroll(true);
        var input = modal.querySelector('input[type="search"]');
        if (input) setTimeout(function () { input.focus(); }, 60);
      });
    });

    modal.querySelectorAll('[data-search-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  /* ---------- Hero slider ---------- */
  function initHero() {
    document.querySelectorAll('[data-hero]').forEach(function (hero) {
      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
      if (slides.length < 2 || !once(hero, 'heroBound')) return;

      var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-dot]'));
      var pauseBtn = hero.querySelector('[data-hero-pause]');
      var interval = parseInt(hero.dataset.autoplay, 10) || 6000;
      var index = 0;
      var timer = null;
      var playing = true;

      function go(next) {
        slides[index].classList.remove('is-active');
        if (dots[index]) dots[index].classList.remove('is-active');
        index = (next + slides.length) % slides.length;
        slides[index].classList.add('is-active');
        if (dots[index]) dots[index].classList.add('is-active');
        var video = slides[index].querySelector('video');
        if (video) { video.currentTime = 0; video.play().catch(function () {}); }
      }

      function start() { timer = setInterval(function () { go(index + 1); }, interval); }
      function stop() { clearInterval(timer); }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { go(i); stop(); if (playing) start(); });
      });

      if (pauseBtn) {
        pauseBtn.addEventListener('click', function () {
          playing = !playing;
          pauseBtn.innerHTML = playing
            ? '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><rect x="6" y="5" width="4" height="14"/><rect x="14" y="5" width="4" height="14"/></svg>'
            : '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
          if (playing) start(); else stop();
        });
      }

      start();
    });
  }

  /* ---------- Carousels ---------- */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      if (!track || !once(carousel, 'carouselBound')) return;
      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      var bar = carousel.querySelector('[data-carousel-bar]');

      function step() {
        var first = track.children[0];
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || '16');
        return first.getBoundingClientRect().width + gap;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max - 4;
        if (bar) {
          var visible = max > 0 ? track.clientWidth / track.scrollWidth : 1;
          var progress = max > 0 ? track.scrollLeft / max : 0;
          bar.style.width = Math.max(visible * 100, 8) + '%';
          bar.style.transform = 'translateX(' + (progress * (100 / Math.max(visible, 0.08) - 100)) + '%)';
        }
      }

      var snapTimer = null;
      function glide(delta) {
        // Temporarily disable snapping: it fights the smooth scroll and makes
        // the track visibly bounce back and forth mid-animation.
        track.style.scrollSnapType = 'none';
        track.scrollBy({ left: delta, behavior: 'smooth' });
        clearTimeout(snapTimer);
        snapTimer = setTimeout(function () { track.style.scrollSnapType = ''; }, 600);
      }
      if (prev) prev.addEventListener('click', function () { glide(-step()); });
      if (next) next.addEventListener('click', function () { glide(step()); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Tabs ---------- */
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (group) {
      if (!once(group, 'tabsBound')) return;
      var buttons = Array.prototype.slice.call(group.querySelectorAll('[data-tab]'));
      var panels = Array.prototype.slice.call(group.querySelectorAll('[data-tab-panel]'));

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.dataset.tab;
          buttons.forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) { p.hidden = p.dataset.tabPanel !== target; });
          window.dispatchEvent(new Event('resize'));
        });
      });
    });
  }

  /* ---------- Product gallery ---------- */
  function initProductGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      if (!once(gallery, 'galleryBound')) return;

      // Product page: the photos sit in a swipeable strip; thumbnails jump
      // to a photo and follow along as the strip is swiped.
      var strip = gallery.querySelector('[data-pdp-gallery]');
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-pdp-thumb]'));
      if (strip && thumbs.length) {
        var mark = function (index) {
          thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
        };
        thumbs.forEach(function (thumb, i) {
          thumb.addEventListener('click', function () {
            strip.scrollTo({ left: i * strip.clientWidth, behavior: 'smooth' });
            mark(i);
          });
        });
        var ticking = false;
        strip.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            mark(Math.round(strip.scrollLeft / strip.clientWidth));
          });
        }, { passive: true });
      }

      var main = gallery.querySelector('[data-gallery-main]');
      if (!main) return;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          main.src = thumb.dataset.full || thumb.querySelector('img').src;
          main.alt = thumb.querySelector('img').alt;
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
          });
        });
      });
    });
  }

  /* ---------- Variant picker ---------- */
  function initVariants() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var form = picker.closest('form');
      if (!form) return;
      var idInput = form.querySelector('[data-variant-id]');
      var priceEl = document.querySelector('[data-product-price]');
      var button = form.querySelector('[data-add-button]');
      var variants = [];
      try { variants = JSON.parse(picker.dataset.variants || '[]'); } catch (e) { variants = []; }

      function selected() {
        return Array.prototype.map.call(picker.querySelectorAll('select'), function (s) { return s.value; });
      }

      picker.addEventListener('change', function () {
        var chosen = selected();
        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === chosen[i]; });
        });
        if (!match) {
          if (button) { button.disabled = true; button.textContent = window.themeStrings.unavailable; }
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceEl && match.price_formatted) priceEl.innerHTML = match.price_formatted;
        if (button) {
          button.disabled = !match.available;
          button.textContent = match.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;
        }
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* ---------- Cart drawer ---------- */
  function initCart() {
    var drawer = document.querySelector('[data-cart-drawer]');

    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      hideScrim();
      lockScroll(false);
    }

    function open() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      lockScroll(true);
      showScrim(close);
    }

    async function refresh() {
      if (!drawer) return;
      try {
        var res = await fetch(window.routes.cart_url + '?section_id=cart-drawer');
        var text = await res.text();
        var parsed = new DOMParser().parseFromString(text, 'text/html');
        var fresh = parsed.querySelector('[data-cart-drawer]');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
        var cart = await (await fetch(window.routes.cart_url + '.js')).json();
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        bindDrawer();
      } catch (e) { /* fail silently, cart page still works */ }
    }

    function bindDrawer() {
      if (!drawer) return;
      drawer.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
      drawer.querySelectorAll('[data-cart-change]').forEach(function (btn) {
        btn.addEventListener('click', async function () {
          // The .js endpoint returns JSON; the plain URL answers with a redirect to /cart
          await fetch(window.routes.cart_change_url + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: Number(btn.dataset.line), quantity: Number(btn.dataset.qty) })
          });
          refresh();
        });
      });
    }

    document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (!drawer) return;
        e.preventDefault();
        open();
      });
    });

    bindDrawer();

    document.querySelectorAll('[data-product-form], form.product-form').forEach(function (form) {
      form.addEventListener('submit', async function (e) {
        if (!drawer) return;
        e.preventDefault();
        var button = form.querySelector('[data-add-button]');
        if (button) button.classList.add('is-disabled');
        try {
          // /cart/add.js reports failures (e.g. sold out) as a 422 with a message;
          // /cart/add would silently redirect to the cart page instead.
          var res = await fetch(window.routes.cart_add_url + '.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          if (res.ok) {
            await refresh();
            open();
          } else {
            var err = await res.json().catch(function () { return {}; });
            window.alert(err.description || err.message || window.themeStrings.unavailable);
          }
        } catch (err) {
          form.submit();
        } finally {
          if (button) button.classList.remove('is-disabled');
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close();
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
          setTimeout(function () { entry.target.classList.add('reveal--done'); }, 900);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Marquee duplication ---------- */
  function initMarquees() {
    document.querySelectorAll('[data-marquee]').forEach(function (marquee) {
      var track = marquee.querySelector('.marquee__track, .logo-strip__track, .visit-marquee__track');
      if (!track || track.dataset.cloned === 'true') return;
      var group = track.children[0];
      if (!group) return;

      // The animation travels -50%, so the track has to be exactly two
      // identical halves. One group is not always a half: with only four
      // logos the group is narrower than the screen, which leaves a gap
      // trailing the last item before the loop restarts. Repeat the group
      // until a half covers the viewport, then mirror that half.
      var groupWidth = group.getBoundingClientRect().width;
      var needed = 1;
      if (groupWidth > 0) {
        needed = Math.ceil(marquee.getBoundingClientRect().width / groupWidth) || 1;
      }

      var half = document.createDocumentFragment();
      for (var i = 1; i < needed; i++) half.appendChild(group.cloneNode(true));
      track.appendChild(half);

      // Mirror everything now in the track to make the second half.
      var mirror = document.createDocumentFragment();
      Array.prototype.forEach.call(track.children, function (child) {
        mirror.appendChild(child.cloneNode(true));
      });
      track.appendChild(mirror);

      track.dataset.cloned = 'true';
    });
  }

  /* ---------- Testimonials duplication ---------- */
  function initTestimonials() {
    document.querySelectorAll('[data-testimonial-col]').forEach(function (col) {
      if (col.dataset.cloned === 'true' || !col.children.length) return;
      var frag = document.createDocumentFragment();
      Array.prototype.forEach.call(col.children, function (child) { frag.appendChild(child.cloneNode(true)); });
      col.appendChild(frag);
      col.dataset.cloned = 'true';
    });
  }

  /* ---------- Back to top ---------- */
  function initBackToTop() {
    document.querySelectorAll('[data-back-to-top]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }

  /* ---------- Sort / facet auto-submit ---------- */
  function initCollectionFilters() {
    // On phones the open filter panels push the product grid far down the page.
    if (window.matchMedia('(max-width: 989px)').matches) {
      document.querySelectorAll('.facets details[open]').forEach(function (d) { d.open = false; });
    }

    document.querySelectorAll('[data-auto-submit]').forEach(function (el) {
      el.addEventListener('change', function () {
        var form = el.closest('form');
        if (form) form.submit();
      });
    });
  }

  function once(el, key) {
    if (!el || el.dataset[key] === 'true') return false;
    el.dataset[key] = 'true';
    return true;
  }

  /* Mega menu close button: hover reopens it, so dismiss until pointer leaves. */
  /* ---------- Desktop navigation ----------
     Hover intent: a short open delay stops panels flashing while the pointer
     sweeps across the menu, and moving between items swaps instantly once one
     is open. Touch devices open on the first tap and follow the link on the
     second. Escape, the close button, or clicking elsewhere closes it. */
  function initMegaMenu() {
    var nav = document.querySelector('[data-nav]');
    if (!nav || !once(nav, 'navBound')) return;

    var items = Array.prototype.slice.call(nav.querySelectorAll('.nav__item--has-drop'));
    var openTimer = null;
    var closeTimer = null;
    var canHover = window.matchMedia('(hover: hover)');

    function setOpen(target) {
      items.forEach(function (item) {
        var on = item === target;
        item.classList.toggle('is-open', on);
        var link = item.querySelector('.nav__link');
        if (link) link.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }

    function anyOpen() { return items.some(function (i) { return i.classList.contains('is-open'); }); }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        if (!canHover.matches) return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function () { setOpen(item); }, anyOpen() ? 0 : 90);
      });

      var link = item.querySelector('.nav__link');
      if (link) {
        link.addEventListener('click', function (e) {
          if (canHover.matches || item.classList.contains('is-open')) return;
          e.preventDefault();
          setOpen(item);
        });
      }
    });

    // Items without a dropdown close whatever is open when hovered
    nav.querySelectorAll('.nav__item:not(.nav__item--has-drop)').forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        clearTimeout(openTimer);
        setOpen(null);
      });
    });

    nav.addEventListener('mouseleave', function () {
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () { setOpen(null); }, 160);
    });

    nav.querySelectorAll('[data-nav-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { setOpen(null); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && anyOpen()) setOpen(null);
    });
    document.addEventListener('click', function (e) {
      if (anyOpen() && !nav.contains(e.target)) setOpen(null);
    });
  }

  /* ---------- Product page: section tabs + sticky buy bar ---------- */
  function initProductPage() {
    var tabs = document.querySelector('[data-pdp-tabs]');
    var bar = document.querySelector('[data-pdp-bar]');
    var form = document.querySelector('.pdp .product-form');

    if (tabs && once(tabs, 'pdpTabsBound')) {
      var links = Array.prototype.slice.call(tabs.querySelectorAll('[data-pdp-tab]'));
      var targets = links
        .map(function (a) { return document.querySelector(a.getAttribute('href')); })
        .filter(Boolean);

      links.forEach(function (a) {
        a.addEventListener('click', function (e) {
          var el = document.querySelector(a.getAttribute('href'));
          if (!el) return;
          e.preventDefault();
          var offset = tabs.getBoundingClientRect().height + 8;
          window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
        });
      });

      // Highlight the tab whose section is currently in view
      if (targets.length && 'IntersectionObserver' in window) {
        var spy = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            links.forEach(function (a) {
              a.classList.toggle('is-active', a.getAttribute('href') === '#' + entry.target.id);
            });
          });
        }, { rootMargin: '-20% 0px -70% 0px' });
        targets.forEach(function (t) { spy.observe(t); });
      }
    }

    // Buy bar appears once the main add-to-cart button has scrolled past
    if (bar && form && once(bar, 'pdpBarBound')) {
      var mainBtn = form.querySelector('[data-add-button]');
      var addBtn = bar.querySelector('[data-pdp-bar-add]');

      if (addBtn && mainBtn) {
        addBtn.addEventListener('click', function () {
          if (typeof form.requestSubmit === 'function') form.requestSubmit(mainBtn);
          else mainBtn.click();
        });
      }

      if (mainBtn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
          });
        }, { threshold: 0 });
        io.observe(mainBtn);
      } else {
        bar.hidden = false;
      }
    }
  }

  /* ---------- Product gallery lightbox ---------- */
  var lightboxKeysBound = false;

  function initLightbox() {
    var box = document.querySelector('[data-pdp-lightbox]');
    if (!box || box.dataset.bound) return;
    box.dataset.bound = '1';

    var img = box.querySelector('[data-pdp-lightbox-img]');
    var count = box.querySelector('[data-pdp-lightbox-count]');
    var closeBtn = box.querySelector('[data-pdp-lightbox-close]');
    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-pdp-zoom]'));
    var index = 0;
    var lastFocused = null;

    function show(i) {
      index = (i + triggers.length) % triggers.length;
      img.src = triggers[index].getAttribute('data-pdp-zoom');
      if (count) count.textContent = index + 1 + ' / ' + triggers.length;
    }

    function open(i) {
      // Clicking a button does not focus it in every browser, so remember the
      // trigger itself rather than whatever happens to be active.
      lastFocused = triggers[i];
      show(i);
      box.hidden = false;
      lockScroll(true);
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      box.hidden = true;
      lockScroll(false);
      if (lastFocused) lastFocused.focus();
    }

    // Keep Tab inside the dialog while it is open.
    function trapTab(event) {
      var items = box.querySelectorAll('button');
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    triggers.forEach(function (trigger, i) {
      trigger.addEventListener('click', function () { open(i); });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);

    var prev = box.querySelector('[data-pdp-lightbox-prev]');
    var next = box.querySelector('[data-pdp-lightbox-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });

    // Clicking the backdrop (but not the image or a control) closes it.
    box.addEventListener('click', function (event) {
      if (event.target === box) close();
    });

    box.lightbox = {
      close: close,
      prev: function () { show(index - 1); },
      next: function () { show(index + 1); },
      trapTab: trapTab
    };

    // One document-level handler for the life of the page. The theme editor
    // swaps the section DOM on every edit, so binding per box would stack up
    // handlers holding detached elements.
    if (!lightboxKeysBound) {
      lightboxKeysBound = true;
      document.addEventListener('keydown', function (event) {
        var live = document.querySelector('[data-pdp-lightbox]');
        if (!live || live.hidden || !live.lightbox) return;
        if (event.key === 'Escape') live.lightbox.close();
        else if (event.key === 'ArrowLeft') live.lightbox.prev();
        else if (event.key === 'ArrowRight') live.lightbox.next();
        else if (event.key === 'Tab') live.lightbox.trapTab(event);
      });
    }
  }

  /* ---------- SEO copy "read more" ---------- */
  function initSeoCopy() {
    document.querySelectorAll('[data-seo-toggle]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';

      var wrap = btn.closest('[data-seo-copy]');
      if (!wrap) return;
      var label = btn.querySelector('span');

      btn.addEventListener('click', function () {
        var collapsed = wrap.classList.toggle('is-collapsed');
        btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        if (label) label.textContent = collapsed ? btn.dataset.more : btn.dataset.less;
        if (collapsed) wrap.scrollIntoView({ block: 'nearest' });
      });

      // Nothing to collapse if the copy already fits.
      if (wrap.scrollHeight <= wrap.clientHeight + 8) {
        wrap.classList.remove('is-collapsed');
        btn.hidden = true;
      }
    });
  }

  /* ---------- Saved watches (wishlist) ----------
     Kept in localStorage: Shopify has no native wishlist, and binding the
     list to the customer account would need an app with Admin API access.
     Stored as product handles so the saved page can look each one up. */
  var SAVED_KEY = 'timepiece:saved';

  function readSaved() {
    try {
      var raw = JSON.parse(localStorage.getItem(SAVED_KEY));
      return Array.isArray(raw) ? raw : [];
    } catch (e) {
      return [];
    }
  }

  function writeSaved(list) {
    try {
      localStorage.setItem(SAVED_KEY, JSON.stringify(list));
    } catch (e) {
      /* private mode or blocked storage - saving just will not persist */
    }
  }

  function updateSavedCount() {
    var n = readSaved().length;
    document.querySelectorAll('[data-saved-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function initWishlist() {
    var saved = readSaved();

    document.querySelectorAll('[data-wishlist-handle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist-handle');
      if (!handle) return;

      if (saved.indexOf(handle) > -1) btn.classList.add('is-saved');
      if (btn.dataset.savedBound) return;
      btn.dataset.savedBound = '1';

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var list = readSaved();
        var at = list.indexOf(handle);
        if (at > -1) {
          list.splice(at, 1);
          btn.classList.remove('is-saved');
        } else {
          list.push(handle);
          btn.classList.add('is-saved');
        }
        writeSaved(list);
        updateSavedCount();
      });
    });

    updateSavedCount();
  }

  /* ---------- Saved page ---------- */
  function initSavedPage() {
    var root = document.querySelector('[data-saved-root]');
    if (!root || root.dataset.savedBound) return;
    root.dataset.savedBound = '1';

    var grid = root.querySelector('[data-saved-grid]');
    var empty = root.querySelector('[data-saved-empty]');
    var loading = root.querySelector('[data-saved-loading]');
    var handles = readSaved();

    function showEmpty() {
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = false;
    }

    if (!handles.length) return showEmpty();

    function money(cents) {
      var n = (Number(cents) || 0) / 100;
      return '£' + n.toLocaleString('en-GB', {
        minimumFractionDigits: n % 1 ? 2 : 0,
        maximumFractionDigits: 2
      });
    }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    function card(p) {
      var img = p.featured_image
        ? '<img src="' + esc(p.featured_image) + '" alt="' + esc(p.title) + '" width="700" height="700" loading="lazy">'
        : '';
      return '<article class="product-card">' +
        '<button type="button" class="product-card__wish is-saved" data-wishlist-handle="' + esc(p.handle) + '"' +
          ' aria-label="Remove from saved">' +
          '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
          '<path d="M12 20.7l-1.4-1.3C5.4 14.9 2.5 12.2 2.5 8.9 2.5 6.4 4.4 4.5 6.9 4.5c1.5 0 2.9.7 3.8 1.8l1.3 1.6 1.3-1.6c.9-1.1 2.3-1.8 3.8-1.8 2.5 0 4.4 1.9 4.4 4.4 0 3.3-2.9 6-7.1 10.5z"/>' +
          '</svg>' +
        '</button>' +
        '<a href="/products/' + esc(p.handle) + '" class="product-card__media">' + img + '</a>' +
        '<div class="product-card__info">' +
          '<h3 class="product-card__title"><a href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a></h3>' +
          '<div class="product-card__price"><span>' + money(p.price) + '</span></div>' +
        '</div>' +
      '</article>';
    }

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      if (loading) loading.hidden = true;

      // Drop anything that has since been deleted or unpublished, and forget it.
      var live = items.filter(Boolean);
      if (live.length !== handles.length) {
        writeSaved(live.map(function (p) { return p.handle; }));
      }
      if (!live.length) return showEmpty();

      grid.innerHTML = live.map(card).join('');
      grid.hidden = false;
      initWishlist();

      // Removing the last one from this page should show the empty state.
      grid.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-wishlist-handle]');
        if (!btn) return;
        setTimeout(function () {
          if (!readSaved().length) {
            grid.hidden = true;
            showEmpty();
          }
        }, 0);
      });
    });
  }

  /* ---------- Sell funnel ----------
     Progressive enhancement: without JS every fieldset is visible and the
     form posts as one page. With JS it becomes one step at a time. */
  function initFunnel() {
    var wrap = document.querySelector('[data-funnel]');
    if (!wrap || wrap.dataset.bound) return;
    wrap.dataset.bound = '1';

    var steps = Array.prototype.slice.call(wrap.querySelectorAll('[data-funnel-step]'));
    if (steps.length < 2) return;

    var form = wrap.closest('form');
    var nav = form.querySelector('[data-funnel-nav]');
    var prev = form.querySelector('[data-funnel-prev]');
    var next = form.querySelector('[data-funnel-next]');
    var bar = form.querySelector('[data-funnel-bar]');
    var current = form.querySelector('[data-funnel-current]');
    var at = 0;

    nav.hidden = false;

    function render() {
      steps.forEach(function (s, i) { s.classList.toggle('is-active', i === at); });
      prev.hidden = at === 0;
      next.hidden = at === steps.length - 1;
      if (bar) bar.style.width = ((at + 1) / steps.length) * 100 + '%';
      if (current) current.textContent = at + 1;
      // Keep the question in view when the step changes on a phone.
      if (at > 0) wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Only block progress on fields this step actually marks as required.
    function valid(step) {
      var fields = step.querySelectorAll('[data-funnel-required]');
      for (var i = 0; i < fields.length; i++) {
        if (!fields[i].value.trim()) {
          fields[i].focus();
          fields[i].classList.add('has-error');
          return false;
        }
        fields[i].classList.remove('has-error');
      }
      return true;
    }

    next.addEventListener('click', function () {
      if (!valid(steps[at])) return;
      if (at < steps.length - 1) { at++; render(); }
    });

    prev.addEventListener('click', function () {
      if (at > 0) { at--; render(); }
    });

    // Enter should advance rather than submit a half-filled form.
    form.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      if (event.target.tagName === 'TEXTAREA') return;
      if (at < steps.length - 1) {
        event.preventDefault();
        next.click();
      }
    });

    render();
  }

  /* ---------- Funnel photo upload ----------
     Files go straight from the browser to Cloudinary using an unsigned
     preset, and the resulting URLs are written into a hidden field so they
     travel with the ordinary Shopify contact form. Shopify itself cannot
     carry attachments, so this is the way to get photos into the enquiry. */
  function initFunnelUpload() {
    var box = document.querySelector('[data-funnel-upload]');
    if (!box || box.dataset.bound) return;
    box.dataset.bound = '1';

    var cloud = box.getAttribute('data-cloud');
    var preset = box.getAttribute('data-preset');
    if (!cloud || !preset) return;

    var input = box.querySelector('[data-funnel-file]');
    var list = box.querySelector('[data-funnel-files]');
    var urlField = box.querySelector('[data-funnel-photo-urls]');
    var errorEl = box.querySelector('[data-funnel-upload-error]');
    var maxFiles = parseInt(box.getAttribute('data-max-files'), 10) || 6;
    var maxBytes = (parseInt(box.getAttribute('data-max-mb'), 10) || 10) * 1024 * 1024;
    var endpoint = 'https://api.cloudinary.com/v1_1/' + encodeURIComponent(cloud) + '/image/upload';
    var uploaded = [];

    function fail(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function clearError() {
      if (errorEl) errorEl.hidden = true;
    }

    function syncField() {
      urlField.value = uploaded.map(function (u) { return u.url; }).join('\n');
    }

    function row(item) {
      var li = document.createElement('li');
      li.className = 'funnel__file';
      li.innerHTML =
        '<span class="funnel__file-name"></span>' +
        '<span class="funnel__file-state">' + '…' + '</span>';
      li.querySelector('.funnel__file-name').textContent = item.name;
      list.appendChild(li);
      return li;
    }

    function upload(file) {
      var item = { name: file.name, url: null };
      var li = row(file);
      var state = li.querySelector('.funnel__file-state');

      var body = new FormData();
      body.append('file', file);
      body.append('upload_preset', preset);

      return fetch(endpoint, { method: 'POST', body: body })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('upload')); })
        .then(function (data) {
          if (!data.secure_url) throw new Error('upload');
          item.url = data.secure_url;
          uploaded.push(item);
          li.classList.add('is-done');
          state.textContent = '✓';
          syncField();
        })
        .catch(function () {
          li.classList.add('is-failed');
          state.textContent = '✕';
          fail(box.getAttribute('data-error') ||
            'One or more photos could not be uploaded. You can send them on WhatsApp instead.');
        });
    }

    input.addEventListener('change', function () {
      clearError();
      var files = Array.prototype.slice.call(input.files || []);
      if (!files.length) return;

      var room = maxFiles - uploaded.length;
      if (files.length > room) {
        fail('You can add up to ' + maxFiles + ' photos.');
        files = files.slice(0, Math.max(room, 0));
      }

      var tooBig = files.filter(function (f) { return f.size > maxBytes; });
      if (tooBig.length) {
        fail('Photos must be under ' + Math.round(maxBytes / 1024 / 1024) + 'MB each.');
      }
      files = files.filter(function (f) { return f.size <= maxBytes; });

      box.classList.add('is-uploading');
      Promise.all(files.map(upload)).then(function () {
        box.classList.remove('is-uploading');
        // Let the same file be chosen again after a removal.
        input.value = '';
      });
    });
  }

  /* ---------- Drawers ----------
     Generic open/close for any [data-drawer="name"], triggered by
     [data-drawer-open="name"]. The filter drawer shipped with the markup and
     the button but nothing listening, so the button did nothing. */
  var drawerKeysBound = false;

  function initDrawers() {
    var active = null;
    var opener = null;

    function close() {
      if (!active) return;
      active.classList.remove('is-open');
      active.setAttribute('aria-hidden', 'true');
      hideScrim();
      lockScroll(false);
      if (opener) opener.focus();
      active = null;
    }

    function open(name, trigger) {
      var drawer = document.querySelector('[data-drawer="' + name + '"]');
      if (!drawer) return;
      if (active && active !== drawer) close();
      active = drawer;
      opener = trigger || null;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      showScrim(close);
      var first = drawer.querySelector('[data-drawer-close]');
      if (first) first.focus();
    }

    document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
      if (btn.dataset.drawerBound) return;
      btn.dataset.drawerBound = '1';
      btn.addEventListener('click', function () {
        open(btn.getAttribute('data-drawer-open'), btn);
      });
    });

    document.querySelectorAll('[data-drawer] [data-drawer-close]').forEach(function (btn) {
      if (btn.dataset.drawerBound) return;
      btn.dataset.drawerBound = '1';
      btn.addEventListener('click', close);
    });

    if (!drawerKeysBound) {
      drawerKeysBound = true;
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        var live = document.querySelector('[data-drawer].is-open');
        if (!live) return;
        var x = live.querySelector('[data-drawer-close]');
        if (x) x.click();
      });
    }

    // An untouched price box would otherwise go into the URL as an empty
    // parameter, so leave blank ones out of the submission.
    document.querySelectorAll("form.facets").forEach(function (form) {
      if (form.dataset.drawerBound) return;
      form.dataset.drawerBound = "1";
      form.addEventListener("submit", function () {
        form.querySelectorAll("input[type=number]").forEach(function (input) {
          if (input.value.trim() === "") input.disabled = true;
        });
      });
    });

    // The quick filter dropdowns are <details>; shut one when another opens
    // or when the click lands anywhere else.
    var pills = Array.prototype.slice.call(document.querySelectorAll('details.filter-pill--drop'));
    pills.forEach(function (pill) {
      if (pill.dataset.drawerBound) return;
      pill.dataset.drawerBound = '1';
      pill.addEventListener('toggle', function () {
        if (!pill.open) return;
        pills.forEach(function (other) { if (other !== pill) other.open = false; });
      });
    });
    if (pills.length && !document.documentElement.dataset.pillsBound) {
      document.documentElement.dataset.pillsBound = '1';
      document.addEventListener('click', function (event) {
        document.querySelectorAll('details.filter-pill--drop[open]').forEach(function (pill) {
          if (!pill.contains(event.target)) pill.open = false;
        });
      });
    }
  }

  /* ---------- Scroll showcase ----------
     The left column is pinned; each photo after the first is clipped to
     nothing and opened from the top edge as its panel scrolls up into view.
     --peel runs 0 (hidden) to 1 (fully drawn). */
  var showcaseBound = false;

  function initShowcase() {
    var wraps = Array.prototype.slice.call(document.querySelectorAll('[data-showcase]'));
    if (!wraps.length) return;
    var desktop = window.matchMedia('(min-width: 990px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var ticking = false;

    function paint() {
      ticking = false;
      var vh = window.innerHeight;
      wraps.forEach(function (wrap) {
        var media = wrap.querySelector('.showcase__media');
        var layers = wrap.querySelectorAll('[data-showcase-layer]');
        var panels = wrap.querySelectorAll('[data-showcase-panel]');
        if (!desktop.matches) {
          for (var k = 0; k < layers.length; k++) layers[k].style.removeProperty('--peel');
          return;
        }
        // Where the pinned photo starts, i.e. just below the sticky header.
        var top = media ? parseFloat(getComputedStyle(media).top) || 0 : 0;
        for (var i = 1; i < layers.length && i < panels.length; i++) {
          var r = panels[i].getBoundingClientRect();
          var p = (vh - r.top) / (vh - top);
          p = p < 0 ? 0 : p > 1 ? 1 : p;
          // No sliding edge for people who ask for less motion: just swap.
          if (reduce.matches) p = p >= 0.5 ? 1 : 0;
          layers[i].style.setProperty('--peel', p.toFixed(4));
        }
      });
    }

    function request() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(paint);
    }

    if (!showcaseBound) {
      showcaseBound = true;
      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request);
    }
    paint();

    // Phones: the panels sit side by side and are paged with the arrows
    // (or a swipe), so the photo and the watches change together.
    wraps.forEach(function (wrap) {
      if (!once(wrap, 'pagerBound')) return;
      var rail = wrap.querySelector('.showcase__panels');
      var prev = wrap.querySelector('[data-showcase-prev]');
      var next = wrap.querySelector('[data-showcase-next]');
      var now = wrap.querySelector('[data-showcase-now]');
      if (!rail || !prev || !next) return;
      var total = rail.children.length;

      function index() {
        return Math.round(rail.scrollLeft / Math.max(rail.clientWidth, 1));
      }
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[data-showcase-tab]'));
      function sync() {
        var i = index();
        prev.disabled = i <= 0;
        next.disabled = i >= total - 1;
        if (now) now.textContent = i + 1;
        tabs.forEach(function (tab, n) {
          var on = n === i;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          // Keep the current brand's tab in view in its own strip.
          if (on && tab.parentNode.scrollWidth > tab.parentNode.clientWidth) {
            tab.parentNode.scrollTo({ left: tab.offsetLeft - 20, behavior: 'smooth' });
          }
        });
      }
      tabs.forEach(function (tab, n) {
        tab.addEventListener('click', function () {
          rail.scrollTo({ left: n * rail.clientWidth, behavior: 'smooth' });
        });
      });
      function go(delta) {
        var i = Math.min(Math.max(index() + delta, 0), total - 1);
        rail.scrollTo({ left: i * rail.clientWidth, behavior: 'smooth' });
      }
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------- Header offset + transparent header ----------
     --header-h-live is the header's real height, used by anything that pins
     itself under it. On the homepage the header also sits over the hero:
     it is pulled up by its own height so the photo runs behind it, and it
     turns solid once the page has moved. */
  var headerBound = false;

  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var overlay = header.classList.contains('header--overlay');
    var box = header.closest('.shopify-section') || header;

    function measure() {
      var hgt = header.offsetHeight;
      document.documentElement.style.setProperty('--header-h-live', hgt + 'px');
      if (overlay) box.style.marginBottom = -hgt + 'px';
      // Lets the first section keep its content clear of the header on top of it.
      document.documentElement.style.setProperty('--header-overlay-h', overlay ? hgt + 'px' : '0px');
    }

    function onScroll() {
      if (overlay) header.classList.toggle('is-solid', window.scrollY > 24);
    }

    measure();
    onScroll();
    if (!headerBound) {
      headerBound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', measure);
      window.addEventListener('load', measure);
    }
  }

  /* ---------- Carousel auto-advance ----------
     Opt-in with data-carousel-auto="seconds". Stops while the pointer or
     keyboard focus is inside, and for anyone who prefers reduced motion. */
  function initCarouselAuto() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-carousel-auto]').forEach(function (carousel) {
      if (!once(carousel, 'autoBound')) return;
      var track = carousel.querySelector('[data-carousel-track]');
      var secs = parseFloat(carousel.getAttribute('data-carousel-auto'));
      if (!track || !(secs > 0)) return;
      var paused = false;

      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
        carousel.addEventListener(ev, function () { paused = true; }, { passive: true });
      });
      ['mouseleave', 'focusout'].forEach(function (ev) {
        carousel.addEventListener(ev, function () { paused = false; });
      });

      setInterval(function () {
        if (paused || document.hidden) return;
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 4) return;
        var r = carousel.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var first = track.children[0];
        var gap = parseFloat(getComputedStyle(track).columnGap || '16');
        var step = first ? first.getBoundingClientRect().width + gap : track.clientWidth;
        track.style.scrollSnapType = 'none';
        if (track.scrollLeft >= max - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: step, behavior: 'smooth' });
        setTimeout(function () { track.style.scrollSnapType = ''; }, 700);
      }, secs * 1000);
    });
  }

  /* ---------- Instagram reel ----------
     Posts may be injected after load (the live feed), so nothing is measured
     up front: sizes are read at the moment an arrow is pressed. */
  function initIgr() {
    document.querySelectorAll('[data-igr]').forEach(function (stage) {
      if (!once(stage, 'igrBound')) return;
      var track = stage.querySelector('[data-igr-track]');
      var root = stage.closest('section') || document;
      var prev = root.querySelector('[data-igr-prev]');
      var next = root.querySelector('[data-igr-next]');
      var bar = root.querySelector('[data-igr-bar]');
      if (!track) return;

      function step() {
        var card = track.querySelector('.igr__card');
        var gap = parseFloat(getComputedStyle(track).columnGap || '16');
        return card ? card.getBoundingClientRect().width + gap : 300;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max - 4;
        if (bar) {
          var count = track.querySelectorAll('.igr__card').length || 1;
          var at = max > 0 ? track.scrollLeft / max : 0;
          bar.style.width = 100 / count + '%';
          bar.style.transform = 'translateX(' + at * (count - 1) * 100 + '%)';
        }
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      // Open a couple of posts in, so there are cards either side of the
      // phone instead of empty space to its left. Only until the visitor
      // scrolls it themselves.
      var touched = false;
      function settle() {
        if (!touched) {
          var count = track.querySelectorAll('.igr__card').length;
          var prevBehavior = track.style.scrollBehavior;
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = step() * Math.min(2, Math.max(count - 1, 0));
          track.style.scrollBehavior = prevBehavior;
        }
        update();
      }
      ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach(function (ev) {
        stage.addEventListener(ev, function () { touched = true; }, { passive: true });
      });
      if (prev) prev.addEventListener('click', function () { touched = true; });
      if (next) next.addEventListener('click', function () { touched = true; });
      // Catch the feed arriving.
      if ('MutationObserver' in window) new MutationObserver(settle).observe(track, { childList: true });
      settle();
    });
  }

  function init() {
    initIgr();
    initHeader();
    initShowcase();
    initCarouselAuto();
    initDrawers();
    initProductPage();
    initLightbox();
    initSeoCopy();
    initWishlist();
    initSavedPage();
    initFunnel();
    initFunnelUpload();
    initMegaMenu();
    initMobileNav();
    initSearch();
    initHero();
    initCarousels();
    initTabs();
    initProductGallery();
    initVariants();
    initCart();
    initReveal();
    initMarquees();
    initTestimonials();
    initBackToTop();
    initCollectionFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init inside the theme editor when a section is re-rendered
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
